// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// Dev environment
// export const environment = {
//   production: false,
//   api_base_url1: "https://api-dev.reliabledrs.com/v1/",
//   api_base_url2: "https://api-dev.reliabledrs.com/v2/",
//   api_base_url3: "https://api-dev.reliabledrs.com/v3/",
//   content_base_url: 'https://content-dev.reliabledrs.com',
//   dummy_img: 'img_avatar.png',
//   wsapiurl: 'wss://4ib2wvx6o1.execute-api.us-east-1.amazonaws.com/dev',
//   razorpay_key: "rzp_test_8EK99OBXheXj4g",
//   razorpay_callback_url: "thirdparty/razorpay?action=callback",
//   dummy_physician_img: 'default_doctor.png'
// };
// QA environment
// export const environment = {
//   production: false,
//   api_base_url1: "https://api-qa.reliabledrs.com/v1/",
//   api_base_url2: "https://api-qa.reliabledrs.com/v2/",
//   api_base_url3: "https://api-qa.reliabledrs.com/v3/",
//   content_base_url: 'https://content-qa.reliabledrs.com',
//   dummy_img: "img_avatar.png",
//   wsapiurl: 'wss://r2i9838tui.execute-api.us-east-1.amazonaws.com/qa',
//   razorpay_key: "rzp_test_8EK99OBXheXj4g",
//   razorpay_callback_url: "thirdparty/razorpay?action=callback",
//   dummy_physician_img: 'default_doctor.png'
// };

// // Prod environment
export const environment = {
  production: true,
  api_base_url1: "https://api.reliabledrs.com/v1/",
  api_base_url2: "https://api.reliabledrs.com/v2/",
  api_base_url3: "https://api.reliabledrs.com/v3/",
  content_base_url: "https://content.reliabledrs.com",
  dummy_img: "img_avatar.png",
  wsapiurl: 'wss://vfbi9k6zb6.execute-api.us-east-1.amazonaws.com/prod',
  razorpay_key: "rzp_live_QH4QG5SrBo1s9c",
  razorpay_callback_url: "thirdparty/razorpay?action=callback",
  dummy_physician_img: 'default_doctor.png'
};









/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
